import { ViewTabs } from '@modules/common/models/enums'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import { PERMISSION_MAP } from '@services/userRoleService'
import { UserRoles } from '@modules/common/models/enums/UserRoles'
import { config } from '@config'

export interface TabViewConf {
  key?: string
  name: ViewTabs
  view?: string[]
  allowedForChannels?: VIPChannel[]
  excludedSubviews?: string[]
  allowedForUsers?: UserRoles[]
  excludedBSGStatuses?: string[]
  translationKey?: string
}

interface ViewMap {
  [key: string]: Array<TabViewConf>
}

// adding this below line from src/stores/strings.ts to remove circular dependency
const strings = {
  grid: 'grid',
  list: 'list',
  kpi: 'kpi'
}

export const ViewTabsMap: ViewMap = {
  [strings.list]: [
    {
      key: ViewTabs.DISTRIBUTION,
      name: ViewTabs.DISTRIBUTION,
      translationKey: 'wholesaleDistribution',
      view: ['collection', 'client', 'cluster'],
      allowedForChannels: [VIPChannel.Wholesale]
    },
    {
      key: ViewTabs.DISTRIBUTION,
      name: ViewTabs.RTL_DISTRIBUTION,
      translationKey: 'retailDistribution',
      view: ['collection', 'client', 'door', 'cluster'],
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      key: ViewTabs.FORECAST,
      name: ViewTabs.FORECAST,
      translationKey: 'retailForecast',
      view: ['collection', 'client', 'door'],
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      key: ViewTabs.BUY,
      name: ViewTabs.BUY,
      translationKey: 'wholesaleBuy',
      view: ['collection', 'client'],
      allowedForChannels: [VIPChannel.Wholesale]
    },
    {
      key: ViewTabs.BUY,
      name: ViewTabs.RTL_BUY,
      translationKey: 'retailBuy',
      view: ['collection', 'client', 'door'],
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      key: ViewTabs.COUNTER_OFFER,
      name: ViewTabs.COUNTER_OFFER,
      translationKey: 'counterOffer',
      view: ['collection'],
      allowedForChannels: [VIPChannel.Retail],
      excludedSubviews: ['overview'],
      allowedForUsers: PERMISSION_MAP.find(ele => VIPChannel.Retail === ele.id)
        .allowedRoles,
      excludedBSGStatuses: [
        config?.appConfig?.enumerations?.retailBuyingSessionStatus
          ?.BUYING_SESSION_STATUS_VALUES.PRE_BUYING
      ]
    }
  ],
  [strings.kpi]: [
    {
      key: ViewTabs.FORECAST,
      name: ViewTabs.FORECAST,
      translationKey: 'retailForecast',
      view: ['collection', 'client'],
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      name: ViewTabs.BUY
    },
    {
      key: ViewTabs.RTL_BUY,
      name: ViewTabs.RTL_BUY,
      translationKey: 'retailBuy',
      view: ['collection', 'client', 'door'],
      allowedForChannels: [VIPChannel.Retail]
    }
  ]
}
